<marv-drawer #drawerAlerts (onDidDismiss)="this.onDidDismissDrawerAlerts($event)">
    <div class="title_card">{{'MESSAGES' | translate}}</div>    
    <app-alert-list />
</marv-drawer>